import { render } from "./BaseSimpleModal.vue?vue&type=template&id=5a1d688a"
import script from "./BaseSimpleModal.vue?vue&type=script&lang=js"
export * from "./BaseSimpleModal.vue?vue&type=script&lang=js"
script.render = render

export default script